import React, {
  useCallback,
  useEffect,
  useState,
  useContext,
  useRef,
} from "react";
import { useTranslation, Trans } from "react-i18next";

import { validateKeylessLocation } from "../keylessService";
import { DomainContext } from "../../../domain-repository/DomainRepository";
import { errorModalImgStyle, keylessColors } from "../utils";

import AlertModalManager from "../../../components/alert-modal-wraper/alert-modal-manager";
import { KeylessButton } from "../components/KeylessButton";
import { KeylessModal } from "../components/KeylessModal";
import { CONVENTION_STEPS } from "./ConventionPage";
import Loading from "../../../components/Loading";
import { VideoView } from "../components/VideoView";

export function ConventionValidateStation({ handleNextStep }) {
  const { t } = useTranslation();

  const { localizationAssets } = useContext(DomainContext);

  const [isLoading, setIsLoading] = useState(false);
  const [openLeaveModal, setOpenLeaveModal] = useState(false);

  const handleNextClick = useCallback(() => {
    handleNextStep(CONVENTION_STEPS.VEHICLE_REVIEW);
  }, [handleNextStep, t]);

  const handleLeaveClick = useCallback(() => {
    window.location.href = "/";
  }, []);

  const [displayInitImage, setDisplayInitImage] = useState(true);

  if (displayInitImage) {
    return (
      <InitView
        videoSrc={localizationAssets["keylessInit"]}
        logoSrc={localizationAssets["keylessGuerinLogo"]}
        text={t("keylessInitMessage")}
        onFinishVideo={() => {
          setDisplayInitImage(false);
        }}
      />
    );
  }

  return (
    <div style={styles.page}>
      <div className="container" style={styles.pageContent}>
        <img
          src={localizationAssets["keylessGuerinLogo"]}
          alt="Guerin"
          style={styles.logo}
        />
        <img
          src={localizationAssets["keylessStationImage"]}
          alt=""
          style={styles.stationImage}
        />
        <p style={styles.title}>{t("conventionEntry")}</p>
        <div className="grid gap-4">
          <KeylessButton
            onClick={handleNextClick}
            text={t("continue")}
            color="white"
            backgroundColor={keylessColors.orange}
            isLoading={isLoading}
          />
        </div>
      </div>
      <KeylessModal
        animation="slide-up"
        isOpen={openLeaveModal}
        img={localizationAssets["keylessError"]}
        imgStyle={errorModalImgStyle}
        title={t("keylessWarning")}
        message={t("keylessNotInStationModal")}
        actions={<KeylessButton onClick={handleLeaveClick} text={t("leave")} />}
      />
    </div>
  );
}

function InitView({ videoSrc, logoSrc, text, onFinishVideo }) {
  const [isLoadingVideo, setIsLoadingVideo] = useState(true);

  return (
    <>
      <Loading active={isLoadingVideo} />
      <div style={styles.initSection}>
        <VideoView
          src={videoSrc}
          style={styles.initVideo}
          hidden={isLoadingVideo}
          onLoaded={() => setIsLoadingVideo(false)}
          onEnded={onFinishVideo}
        />
        <img style={isLoadingVideo ? { display: "none" } : styles.initLogo} src={logoSrc} alt="" />
        <div
          className={isLoadingVideo ? "hidden" : "fade-in"}
          style={styles.initText}
        >
          {text}
        </div>
      </div>
    </>
  );
}

const styles = {
  initSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    height: "100dvh",
    padding: "10% 0 50%",
  },
  initVideo: {
    height: "100dvh",
    position: "absolute",
    top: "0",
    left: "50%",
    transform: 'translateX(-50%)',
    zIndex: "1",
  },
  initLogo: {
    width: "40%",
    maxWidth: "200px",
    zIndex: 3,
  },
  initText: {
    color: "white",
    fontSize: "2.5rem",
    textAlign: "center",
    fontFamily: "'BlissLight'",
    width: "60%",
    zIndex: 3,
  },
  page: {
    backgroundColor: keylessColors.green,
    height: "100dvh",
    paddingBottom: "60px",
    paddingTop: "30px",
    fontFamily: "'BlissLight'",
  },
  pageContent: {
    textAlign: "center",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
  },
  logo: {
    height: "10vh",
    margin: "0 auto",
  },
  stationImage: {
    height: "20vh",
    margin: "0 auto",
  },
  title: {
    color: "white",
    fontSize: "2rem",
    flex: "1",
    margin: "0",
    lineHeight: "normal",
  },
};
